module.exports = __webpack_public_path__ + "img/group-chat.81734069.svg";